"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailField = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../shared/core");
var copy_1 = require("../../../../copy");
var EmailField = function (_a) {
    var value = _a.value, error = _a.error, handler = _a.handler;
    var copy = (0, core_1.useCopy)(copy_1.defaultOptions).copy;
    var _b = (0, core_1.useComponents)(), Pii = _b.Pii, EmailField = _b.EmailField;
    return (react_1.default.createElement(Pii, { as: "div" },
        react_1.default.createElement(EmailField, { autoComplete: copy('profile.emailAutocomplete'), id: "email", characters: 25, error: error, label: copy('profile.emailLabel'), onChange: handler, value: value, "data-testid": "email-field" })));
};
exports.EmailField = EmailField;
